import SignUp from './Components/SignUp/SignUp';
import './App.css';
import React from 'react';
import {Route, Routes, HashRouter as Router} from 'react-router-dom';
import ReportForm from './Components/ReportForm/ReportForm';
import ResetPassword from './Components/ResetPassword/ResetPassword';

  const App = () => {
    return (
      <div>
      <Router>
          <Routes>
            <Route exact path="/" element={<SignUp />} />
            <Route  path="/SignUp" element={<SignUp />} />
            <Route path="/ReportForm" element={<ReportForm />} />
            <Route path="/ResetPassword" element={<ResetPassword />} />
          </Routes>
      </Router>
      </div>
    );
  };
export default App;